export const CANCEL_MEMBERSHIP_STEP = {
  START_CANCEL: "START CANCEL",
  QUESTIONNAIRE: "QUESTIONNAIRE",
  CONFIRM: "CONFIRM",
}



// WEBPACK FOOTER //
// ./src/constants/setting.js